import { useEffect } from "react";

// Set/replace a meta tag (by name or property) on the document head.
function upsertMeta({ name, property, content }) {
  if (!content) return;
  const selector = name ? `meta[name="${name}"]` : `meta[property="${property}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    if (name) el.setAttribute("name", name);
    if (property) el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink({ rel, href }) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertJsonLd(id, json) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.setAttribute("type", "application/ld+json");
    el.setAttribute("id", id);
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(json);
}

/**
 * <SeoHead title="..." description="..." image="..." canonical="..." jsonLd={...} />
 * Renders nothing. Updates DOM head tags.
 */
export default function SeoHead({ title, description, image, canonical, jsonLd, jsonLdId = "ld-main" }) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta({ name: "description", content: description });
    upsertMeta({ property: "og:title", content: title });
    upsertMeta({ property: "og:description", content: description });
    upsertMeta({ property: "og:type", content: "website" });
    upsertMeta({ property: "og:image", content: image });
    upsertMeta({ name: "twitter:card", content: image ? "summary_large_image" : "summary" });
    upsertMeta({ name: "twitter:title", content: title });
    upsertMeta({ name: "twitter:description", content: description });
    upsertMeta({ name: "twitter:image", content: image });
    upsertLink({ rel: "canonical", href: canonical || window.location.href });
    if (jsonLd) upsertJsonLd(jsonLdId, jsonLd);
  }, [title, description, image, canonical, jsonLd, jsonLdId]);
  return null;
}
